<template>
  <div class="back-link-container">
    <a
      class="back-link"
      @click="onBack ? onBack() : onBackToUrl()"
    >
      <BIconArrowLeft class="mr-2" />{{ 'back' | i18n }}
    </a>
  </div>
</template>

<script>
import { BIconArrowLeft } from 'bootstrap-vue';

export default {
  name: 'GoBack',
  components: { BIconArrowLeft },
  props: {
    backUrl: {
      type: String,
      default: '',
    },
    onBack: {
      type: [Function, Boolean],
      default: false,
    },
  },
  methods: {
    onBackToUrl() {
      if (this.backUrl) {
        this.$router.push(this.backUrl);
        return;
      }
      if (this.$route.meta.isGoBackUrl && this.$route.params.id) {
        this.$router.push({ name: this.$route.meta.isGoBackUrl, params: { id: this.$route.params.id } });
        return;
      }
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped lang="scss">
.back-link-container {
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;

  .back-link {
    position: relative;
    color: #007bff;
    cursor: pointer;
  }
}
</style>
